import type { ContextualPricingApi } from '@openx/types/targeting/contextualPricing.ts';
import type { UseGetContextualPricing } from '@openx/types/targeting/targetingHookTypes.ts';

/** Whether the API returned any partner owed a contextual fee (it returns null when nothing is owed). */
export const hasContextualFees = (contextualPricing?: ContextualPricingApi | null): boolean =>
  !!contextualPricing && Object.keys(contextualPricing.pricing_by_org ?? {}).length > 0;

/** Stand-in for apps that don't provide `useGetContextualPricing`: no contextual fees there. */
export const useNoContextualPricing: UseGetContextualPricing = () => ({ data: null, loading: false });
